import React, {useEffect} from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card } from '../../Components/Cards/Card';
import Loader from '../../Components/Loader/Loader';
import { useNavigate } from 'react-router-dom';



const Dashboard = () => {
  const navigate = useNavigate();
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ['userStats'],
    queryFn: async () => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response?.status == 401) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 400) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 500) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      } else {
        return response.json();
      }
    },

  });


  useEffect(() => {
    const intervalId = setInterval(() => {
      refetch(); // Refetch data every 5 seconds
    }, 5000);

    return () => clearInterval(intervalId); // Clean up interval on component unmount
  }, [refetch]);


  // const { data, isLoading, error } = useQuery(['userStats'], fetchUserStats);

  // if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;


  return (
    <div>
      <div className="flex justify-center gap-6 w-full max-w-6xl mx-auto min-h-full h-svh ">
        <Card className="p-6 max-h-40 rounded-lg shadow-lg flex-1 bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100">
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-2xl font-semibold">Total Users</h3>
            <div className="text-5xl font-bold"> {isLoading ? <Loader /> : data?.data?.users}</div>
            <p className="text-sm text-foreground dark:text-gray-100">
              Active users on the platform
            </p>
          </div>
        </Card>
        <Card className="p-6 max-h-40 rounded-lg shadow-lg flex-1 bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100">
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-2xl font-semibold">Total Videos</h3>
            <div className="text-5xl font-bold">{isLoading ? <Loader /> : data?.data?.videos}</div>
            <p className="text-sm text-foreground dark:text-gray-100">
              Videos uploaded by users
            </p>
          </div>
        </Card>
        <Card className="p-6 max-h-40 rounded-lg shadow-lg flex-1 bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100">
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-2xl font-semibold">Total Reports</h3>
            <div className="text-5xl font-bold">{isLoading ? <Loader /> : data?.data?.reports}</div>
            <p className="text-sm text-foreground dark:text-gray-100">
              User-submitted reports
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
